<template>
    <v-container>
        <v-data-table :headers="headers" :items="desserts" :search="search" :loading="loading" sort-by="email" class="elevation-1" hide-default-footer :page.sync="page" :items-per-page="itemsPerPage"  @page-count="pageCount = $event">
            <template v-slot:top>
              <div> <p class="header-title pt-5 pl-5"> {{$t('menu.permision')}} </p></div>

              <v-container align="center">
                <v-row justify="start">
                  <v-col cols="12" sm="1">
                      <v-autocomplete v-model="itemsPerPage" :items="numberPage" v-bind:label="$t('common.row_per_page')" outlined></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>

              <v-toolbar flat color="white">
                  <v-dialog v-model="dialog" persistent max-width="600px">
                      <template v-slot:activator="{ on }">
                          <v-btn color="primary" dark class="mb-2" v-on="on">{{ $t('common.add')}}</v-btn>
                      </template>
                      <v-card>
                          <v-card-title>
                              <span class="headline">{{ formTitle }}</span>
                          </v-card-title>

                          <v-card-text>
                              <v-container>
                                  <v-row>
                                      <v-col>
                                          <v-text-field v-model="editedItem.name" :rules="stringRules" v-bind:label="$t('permission_management.name')"></v-text-field>
                                      </v-col>
                                  </v-row>
                                  <v-row>
                                      <v-col>
                                          <v-text-field v-model="editedItem.description" v-bind:label="$t('permission_management.description')"></v-text-field>
                                      </v-col>
                                  </v-row>
                                  <v-row>
                                      <v-col>
                                          <v-text-field v-model="editedItem.value" :rules="stringRules" v-bind:label="$t('permission_management.value')"></v-text-field>
                                      </v-col>
                                  </v-row>
                                    
                              </v-container>
                          </v-card-text>

                          <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="blue darken-1" text @click="close">{{ $t('common.cancel')}}</v-btn>
                              <v-btn color="blue darken-1" text @click="save">{{ $t('common.save')}}</v-btn>
                          </v-card-actions>
                      </v-card>
                  </v-dialog>

                  <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="search" v-bind:label="$t('common.search')" single-line hide-details></v-text-field>
              </v-toolbar>
            </template>

            <!-- <template v-slot:item.action="{ item }">
                <v-icon  small class="mr-2"  @click="editItem(item)">
                    edit
                </v-icon>
                <v-icon  small @click="deleteItem(item)">
                    delete
                </v-icon>

            </template> -->

            <template v-slot:[`item.type`]="{ item }">
                {{ getViewName(item) }}
            </template>

            <template v-slot:no-data>
                <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            </template>
        </v-data-table>

        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
    </v-container>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,

      loading: true,
      numberPage: [
        5, 10, 15, 20, 25
      ],

      search: '',
      dialog: false,
      headers: [
        { text: '#', align: 'left', sortable: false, value: 'index', },
        { text: i18n.t('permission_management.name'), value: 'name' },
        { text: i18n.t('permission_management.description'), sortable: false, value: 'description' },
        { text: i18n.t('permission_management.value'), sortable: false, value: 'value' },
        // { text: '', value: 'action', sortable: false }
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
      },
      stringRules: [
          v => !!v || i18n.t('validate.not_empty'),
          v => (v && v.length > 5) || i18n.t('validate.string_invalid')
      ]
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? i18n.t('permission_management.add') : i18n.t('permission_management.edit')
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    async mounted() {
    //   await this.getData()
    },

    methods: {
      initialize () {
    //     this.selectType = this.types[1];
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const agree = confirm(i18n.t('common.confirm_delete'))
        console.log(agree);
        if (agree) {
          const response =  await this.$http.delete("/context/" + item._id);
          if(response.data && response.data.success) {
              // console.log(response.data);
              this.desserts.splice(item.index - 1, 1);
              this.desserts.forEach((item, index) =>item.index = index + 1);
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      async save () {
        if (this.editedIndex > -1) {
          const self = this;
          const requestBody = self.editedItem;
          requestBody.type = this.selectType.value;

          try {
              const response = await this.$http.put(process.env.VUE_APP_CONTEXT_URL + self.editedItem._id, requestBody);
              if (response.data && response.data.success) {
                  // console.log(response.data);
                  Object.assign(this.desserts[this.editedIndex], this.editedItem);
                  self.editedItem = {};
              }
            } catch (e) {
                console.log(e.stack);
            }
        } else {
            const self = this;
            const requestBody = self.editedItem;
            requestBody.type = this.selectType.value;
            try {
                const response =  await this.$http.post(process.env.VUE_APP_CONTEXT_URL, requestBody);
                if(response.data && response.data.success) {
                    // console.log(response.data);

                    self.editedItem._id = response.data.data.id;
                    
                    this.desserts.push(self.editedItem);
                    self.editedItem.index = this.desserts.length;
                    self.editedItem = {};

                    this.$fire({
                        title: i18n.t('common.success'),
                        text: "",
                        type: "success"
                        }).then(() => {
                            
                    });

                }
            } catch(e) {
                console.log(e.stack);
            }
        }
        this.close()
      },

      getViewName(item) {
        if (item.type) {
          return this.types[item.type].name;
        }
        
        return '';
      },

      async getData() {
        try {
            const response =  await this.$http.get(process.env.VUE_APP_GET_BLOCK_URL);
            if(response.data && response.data.success) {
                // console.log(response.data);
                
                const contextArr = response.data.data;
                contextArr.forEach((item, index) =>item.index = index + 1);

                this.desserts = contextArr;
                this.loading = false;
            }
        } catch(e) {
            console.log(e.stack);
        }
      }
    },
  }
</script>